import React, { useMemo } from 'react';
import { Link } from 'react-scroll';
import ImgPicture from './img-picture';
const HeaderSliderItem = ({ saleItem }) => {
    const idName = useMemo(() => (`TOP_Slider_${saleItem.image_name}`), []);
    return (React.createElement(Link, { to: `_${saleItem.image_name}`, smooth: true, duration: 300, id: idName },
        React.createElement(ImgPicture, { fileName: `./assets/img/sale-item/${saleItem.image_name}`, alt: saleItem.name, ext: 'jpg' })));
};
export default HeaderSliderItem;
